<template>
  <div>
    <strong v-if="location === 'general-info'">{{
      trans("examination.flaggedCaseLabel")
    }}</strong>

    <div class="text-muted">
      <i class="fas fa-flag" :title="trans('general.caseFlaggedTitle')" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    location: String,
  },
};
</script>
